export interface UpayaPengelolaanRisikoMain {
  id: number;
  ulid: string;
  parameter: string;
  nilai: string;
  created_at: string;
  updated_at: string;
}

export interface UpayaPengelolaanRisikoDataModel {
  main: {
    data: UpayaPengelolaanRisikoMain[];
    total: number;
  };
}

export enum UpayaPengelolaanRisikoActionType {
  GetUpayaPengelolaanRsiiko = "⌘➝Parameter Setting➝Scoring➝GetUpayaPengelolaanRsiiko",
}

export type UpayaPengelolaanRisikoAction = {
  type: UpayaPengelolaanRisikoActionType.GetUpayaPengelolaanRsiiko;
  data: {
    data: UpayaPengelolaanRisikoMain[];
    total: number;
  };
};
